import * as types from 'actions/types';
import { chatUITabs } from 'constants/chatUI';
import dotProp from 'dot-prop-immutable';
import cloneDeep from 'lodash/cloneDeep';
import omit from 'lodash/omit';

const INITIAL_STATE = {
  status: { isOpen: false, isOnscreen: false, activeTab: null },
  productRecMacroCopied: {},
};

const chatUI = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SET_CHAT_UI_STATUS:
      // isOnscreen true and isOpen false means that the ChatUI window state is closed, but onscreen as a toolbar that can be opened. Both false means nothing is onscreen.
      return dotProp.set(state, 'status', {
        isOpen: action.payload.isOpen,
        isOnscreen: action.payload.isOnscreen,
        activeTab: action.payload.activeTab,
      });
    case types.SET_CHAT_PRODUCT_REC_MACRO_COPIED:
      return dotProp.set(state, 'productRecMacroCopied', {
        ...state.productRecMacroCopied,
        [action.payload.ticketId]: action.payload.productRecMacroCopied,
      });
    case types.ADD_MESSAGE:
      const currentTicketId = action.ticketId;
      const ticketsWithProductRecMacroCopied = cloneDeep(state.productRecMacroCopied);
      const productRecMacroWasCopied = Object.keys(ticketsWithProductRecMacroCopied).includes(currentTicketId);

      if (productRecMacroWasCopied && action.productRecsExist) {
        return dotProp.set(state, 'status', {
          isOpen: true,
          isOnscreen: true,
          activeTab: chatUITabs.productRecs.tabName,
        });
      }

      return state;
    case types.REMOVE_TICKET:
      if (action.queueName === 'assigned') {
        const productRecMacroCopiedState = cloneDeep(state.productRecMacroCopied);
        const cleanObj = omit(productRecMacroCopiedState, [action.ticketId]);

        return dotProp.set(state, 'productRecMacroCopied', {
          ...cleanObj,
        });
      }

      return state;
    default:
      return state;
  }
};

export default chatUI;
